import { defineMessages } from 'react-intl';

export const threadFooterMessages = defineMessages({
  answer: { defaultMessage: 'Répondre au sujet', id: 'Xq2FAm' },
  newMessage: { defaultMessage: 'Nouveau message', id: 'e1rfKR' },
  replyToThreadAuthor: {
    defaultMessage: '<styledSpan>Répondre à </styledSpan> {authorWithAvatar}',
    id: 'RAiWxB',
  },
  backButtonLabel: { defaultMessage: 'Discussion', id: '20bImY' },
  answerTo: { defaultMessage: 'Vous répondez à', id: 'ULkZAc' },
});
